/**
 * Per-page font preload hints.
 *
 * The @font-face declarations themselves are sitewide in assets/scss/fonts.scss
 * — that is what makes a family usable anywhere without a render-blocking
 * stylesheet link, and it is where a new family belongs. These preloads are a
 * separate, purely optional layer: they only tell the browser to start the
 * download in parallel with the app CSS instead of waiting for it.
 *
 * Preloads stay page-scoped on purpose. A sitewide preload of the blog faces
 * would pull ~84 KB on every product and checkout page that never paints them
 * (`fetchpriority` aside, an unused preload is wasted bandwidth and logs a
 * "preloaded but not used" warning). Satoshi is the one font preloaded globally
 * in nuxt.config.js, because every page renders it.
 *
 * Only the `latin` subsets are listed: those are the ones the blog's copy
 * actually paints. The latin-ext files are left to load on demand.
 *
 * Each href must stay byte-identical to the matching `src` in fonts.scss or the
 * font is fetched twice, and `crossorigin` is required even same-origin because
 * fonts are always fetched in CORS mode — without it the preload does not match
 * the CSS request and, again, downloads twice.
 */

const preloadFont = (href) => ({
  hid: `preload-${href}`,
  rel: "preload",
  as: "font",
  type: "font/woff2",
  href,
  crossorigin: "anonymous",
});

// Exo 2 for headings, Open Sans for body — both painted above the fold on the
// listing and the article. Open Sans italic is not preloaded: it first appears
// in captions and the answer capsule, below the fold.
export const BLOG_FONT_PRELOADS = [
  preloadFont("/fonts/Exo2-Variable-latin.woff2"),
  preloadFont("/fonts/OpenSans-Variable-latin.woff2"),
];
